/**
 * The Fetch API provides a JavaScript interface for accessing and manipulating parts of the HTTP pipeline,
 * such as requests and responses. It also provides a global fetch() method that provides an easy,
 * logical way to fetch resources asynchronously across the network.
 */

import { AUTH_TOKEN_KEY } from "utils/constants";
import { getItemFromStorage } from "utils/storage";

const initOptions = (otherHeaders = {}) => {
  let headers = { "Content-Type": "application/json", ...otherHeaders };
  const token = getItemFromStorage(AUTH_TOKEN_KEY);
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return { headers };
};

const get = (url, options) => {
  const requestOptions = {
    method: "GET",
    ...options,
    ...initOptions(),
  };
  return fetch(url, requestOptions).then(handleResponse);
};

const post = (url, body, headers, options) => {
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(body),
    ...options,
    ...initOptions(headers),
  };
  return fetch(url, requestOptions).then(handleResponse);
};

const put = (url, body, headers, options) => {
  const requestOptions = {
    method: "PUT",
    body: JSON.stringify(body),
    ...options,
    ...initOptions(headers),
  };
  return fetch(url, requestOptions).then(handleResponse);
};

// prefixed with underscored because delete is a reserved word in javascript
const del = (url, options) => {
  const requestOptions = {
    method: "DELETE",
    ...options,
    ...initOptions(),
  };
  return fetch(url, requestOptions).then(handleResponse);
};

// helper function
function handleResponse(response) {
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return response.body;
}

export const fetchService = {
  get,
  post,
  put,
  delete: del,
};
